var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppPlaceholder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "App icon placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-icon-placeholder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E5F8FD",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9716176,72.2948461 C48.9716176,72.5492384 48.9212504,72.8011135 48.8234212,73.035943 C48.4141247,74.0184191 47.28587,74.483073 46.3033939,74.0737766 L26.891242,65.986735 C26.1730478,65.6875375 25.705212,64.985829 25.705212,64.2078045 L25.705212,40.1803522 C25.705212,39.9258792 25.7556111,39.6739258 25.8535007,39.439034 C26.2629195,38.4566088 27.3912319,37.9920953 28.3736571,38.4015141 L47.785809,46.4913918 C48.5038854,46.7906451 48.9716176,47.4922928 48.9716176,48.2702299 L48.9716176,72.2948461 Z",
    id: "Path",
    fill: "#029DD0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0283824,72.2948461 C51.0283824,72.5492384 51.0787496,72.8011135 51.1765788,73.035943 C51.5858753,74.0184191 52.71413,74.483073 53.6966061,74.0737766 L73.108758,65.986735 C73.8269522,65.6875375 74.294788,64.985829 74.294788,64.2078045 L74.294788,40.1803522 C74.294788,39.9258792 74.2443889,39.6739258 74.1464993,39.439034 C73.7370805,38.4566088 72.6087681,37.9920953 71.6263429,38.4015141 L52.214191,46.4913918 C51.4961146,46.7906451 51.0283824,47.4922928 51.0283824,48.2702299 L51.0283824,72.2948461 Z",
    id: "Path",
    fill: "#3DD1F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5294105,33.2936237 C68.9739984,33.4788979 69.3273763,33.8323286 69.5125842,34.2769441 C69.9003603,35.2078511 69.4600658,36.2768549 68.5291589,36.6646311 L50.8305131,44.0371321 C50.3811404,44.2243216 49.8756243,44.2243216 49.4262515,44.0371321 L31.7276058,36.6646311 C31.2829903,36.4794232 30.9295596,36.1260453 30.7442854,35.6814574 C30.3563702,34.7506084 30.7965051,33.6815388 31.7273542,33.2936237 L49.4259999,25.9180212 C49.8755192,25.7306919 50.3812455,25.7306919 50.8307648,25.9180212 L68.5294105,33.2936237 Z",
    id: "Path",
    fill: "#066084",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/App-placeholder.0a61f1b1b312d7e601298df47eae990c.svg";